import { createContext, useContext, useEffect, useState } from 'react';

interface INavbarContextProps {
  showNavbar: boolean;
  isMobile: boolean;
  showMobileNavbar: boolean;
  setIsMobile: React.Dispatch<React.SetStateAction<boolean>>;
  setShowNavbar: React.Dispatch<React.SetStateAction<boolean>>;
  setShowMobileNavbar: React.Dispatch<React.SetStateAction<boolean>>;
}

// creating the context here
const NavbarContext = createContext<INavbarContextProps | null>(null);

const NavbarProvider = ({ children }: { children: React.ReactNode }) => {
  // integration of react hooks here
  const [showNavbar, setShowNavbar] = useState<boolean>(true);
  const [showMobileNavbar, setShowMobileNavbar] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);

  // checking if the device is mobile or not here
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // rendering the context provider here
  return (
    <NavbarContext.Provider
      value={{
        showNavbar,
        setShowNavbar,
        isMobile,
        setIsMobile,
        showMobileNavbar,
        setShowMobileNavbar,
      }}
    >
      {children}
    </NavbarContext.Provider>
  );
};

export default NavbarProvider;

// custom hook to access navbar context declared here
export const useNavbarContext = () => {
  const context = useContext(NavbarContext);

  if (!context) {
    throw new Error('useNavbarContext must be within NavbarProvider!');
  }

  return context;
};
